import { SxProps, Theme } from "@mui/material";

export const timerPillRootSx: SxProps<Theme> = (theme) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  px: { xs: 0.75, sm: 1.5 },
  py: { xs: 0.25, sm: 0.5 },
  borderRadius: "10px",
  background:
    theme.palette.mode === "dark"
      ? "linear-gradient(180deg, rgba(193, 147, 55, 0.35) 0%, rgba(125, 92, 24, 0.28) 100%)"
      : "linear-gradient(180deg, #FEF3C7 0%, #FDE68A 100%)",
  border: `1px solid ${
    theme.palette.mode === "dark"
      ? "rgba(228, 198, 126, 0.35)"
      : "rgba(180, 120, 20, 0.45)"
  }`,
  boxShadow:
    theme.palette.mode === "dark"
      ? "0 6px 18px rgba(0,0,0,0.35)"
      : "0 1px 3px rgba(146, 64, 14, 0.12)",
  backdropFilter: theme.palette.mode === "dark" ? "blur(8px)" : "none",
});

export const timerPillTextSx: SxProps<Theme> = (theme) => ({
  fontSize: { xs: 10, sm: 12 },
  fontWeight: 900,
  letterSpacing: 0.6,
  color:
    theme.palette.mode === "dark"
      ? "rgba(242, 226, 186, 0.95)"
      : "#78350F",
  textTransform: "uppercase",
  whiteSpace: "nowrap",
});
